<script setup>
import SInfoMontant from '@/components/global/s-info-montant.vue'
import LigneVersementChip from '@/components/fiche-aim/fiche-aim/versements/versementList/ligne-versement-chip.vue'

defineEmits(['delete-versement'])
</script>

<template>
  <tr>
    <td style="width: 20%" class="text-body-1" colspan="1">
      <span>
        <v-icon left>{{ icone }}</v-icon>
        {{ versement.moyenDePaiement.libelle }}
      </span>
    </td>
    <td style="width: 70%" class="text-right">
      <ligne-versement-chip
        class="mb-1"
        v-for="ligne in versement.lignesVersements"
        :key="ligne.ligneVersementId"
        :ligne="ligne"
      />
    </td>
    <td style="min-width: 5%" class="text-body-1 mb-0 ml-4 text-left">
      <s-info-montant afficher-devise :montant="montantTotal" />
    </td>
    <td style="width: 5%">
      <v-btn :disabled="versement.estVerse" icon color="error" @click="handleDelete"><v-icon>mdi-delete</v-icon></v-btn>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'versement-list-item',
  props: {
    versement: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      getIconeType: 'moyenDePaiement/getIconePourMoyenDePaiementAimId',
    }),
    icone() {
      return this.getIconeType(this.versement.moyenDePaiement.moyenDePaiementId)
    },
    montantTotal() {
      let sum = 0
      this.versement.lignesVersements.forEach((l) => (sum += l.montant))
      return sum
    },
  },
  methods: {
    handleDelete() {
      this.$emit('delete-versement')
    },
  },
}
</script>

<style scoped></style>
